import { createAction } from '@reduxjs/toolkit'

// toggleNavigationOpen
export const toggleOpen = createAction('toggle_navigation_menu_open')

// toggleNavigationItem (payload is the item id)
export const toggleItem = createAction<string>('toggle_navigation_menu_item')
